import React, { useState } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { Button, Input } from 'antd';
import { notification } from 'ui';

const { TextArea } = Input;

const StyledInfo = styled.p`
  margin-top: 10px;
`;

const StyledInfoReference = styled.p`
  margin-top: 10px;
  font-size: 12px;
`;

const ErrorTitle = styled.p`
  font-weight: bold;
  font-size: 15px;
`;

const ExtraInfoText = styled.p`
  font-size: 12px;
  text-decoration: underline;
  color: #0099cc;
  cursor: pointer;
`;

const Rules = styled.div`
  margin-left: 20px;
`;

const StyledButton = styled(Button)`
  float: right;
  color: white;
  background-color: #6f7e95;
  width: 80px;
  &:hover {
    opacity: 0.7;
    color: white;
    background-color: #6f7e95;
    border-color: #6f7e95;
  }
`;

const CopyButton = styled(Button)`
  text-transform: uppercase;
  margin: 10px 0;
  color: #6f7e95 !important;
  background-color: white !important;
  border-color: #6f7e95 !important;
  &:hover {
    opacity: 0.7;
    color: #6f7e95 !important;
    background-color: white !important;
    border-color: #6f7e95 !important;
  }
`;

const ButtonContainer = styled.div`
  margin-top: 10px;
  width: 100%;
`;

const StyledTextArea = styled(TextArea)`
  font-size: 14px !important;
  color: rgba(0, 0, 0, 0.85) !important;
`;

const UploadCSVError = ({ error, renderRules, intl }) => {
  const [showRules, setShowRules] = useState(false);

  const renderErrorList = () => {
    let result = '';
    error.errors?.map((e) => {
      e?.map((l) => {
        if (result) {
          result = `${result}
${l}`;
        } else {
          result = l;
        }
        return l;
      });
      result = `${result}
`;
      return e;
    });
    return result;
  };

  const errorList = renderErrorList();

  return (
    <>
      <ErrorTitle>{error.title}</ErrorTitle>
      <p>{error.message}</p>
      <ExtraInfoText onClick={() => setShowRules(rule => !rule)}>
        {showRules ?
          intl.formatMessage({ id: 'holidays.HIDE_RULES' }) :
          intl.formatMessage({ id: 'holidays.SHOW_RULES' })
        }
      </ExtraInfoText>
      {showRules &&
        <>
          <p>{intl.formatMessage({ id: 'holidays.EXPECTED_FORMAT' })}{':'}</p>
          <Rules>
            {renderRules(intl)}
          </Rules>
        </>
      }
      <StyledInfo>
        {`${intl.formatMessage({ id: 'holidays.UPLOAD_ERROR_INSTRUCTIONS' })}:`}
      </StyledInfo>
      <StyledTextArea
        rows={8}
        disabled={true}
        value={errorList}
      />
      <CopyToClipboard text={errorList}>
        <ButtonContainer>
          <CopyButton>{intl.formatMessage({ id: 'holidays.COPY_TO_CLIPBOARD' })}</CopyButton>
        </ButtonContainer>
      </CopyToClipboard>
      <StyledInfoReference>{error.reference}</StyledInfoReference>
      <ButtonContainer>
        <StyledButton
          onClick={() => notification.destroy('errorUploadNotification')}
        >
          {intl.formatMessage({ id: 'common.OK' })}
        </StyledButton>
      </ButtonContainer>
    </>
  );
};
UploadCSVError.propTypes = {
  error: PropTypes.object,
  intl: PropTypes.object,
  renderRules: PropTypes.func,
};

export default UploadCSVError;
